const MAP = {
  // legacy statuses
  Draft: "bg-slate-100 text-slate-700 border-slate-300",
  Active: "bg-blue-50 text-blue-700 border-blue-200",
  Hold: "bg-amber-50 text-amber-700 border-amber-200",
  Closed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  // stages
  "Menunggu Persetujuan": "bg-amber-50 text-amber-700 border-amber-200",
  "Menunggu Jadwal Masuk": "bg-amber-50 text-amber-700 border-amber-200",
  "Siap Masuk": "bg-sky-50 text-sky-700 border-sky-200",
  "On Production": "bg-slate-100 text-slate-700 border-slate-300",
  "Body Repair": "bg-blue-50 text-blue-700 border-blue-200",
  Dempul: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Cat: "bg-purple-50 text-purple-700 border-purple-200",
  Finishing: "bg-amber-50 text-amber-700 border-amber-200",
  Ready: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Fabrikasi Rangka": "bg-blue-50 text-blue-700 border-blue-200",
  "Pemasangan Body": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Kelistrikan & Aksesoris": "bg-indigo-50 text-indigo-700 border-indigo-200",
  QC: "bg-lime-50 text-lime-700 border-lime-300",
  "Unit Out": "bg-teal-50 text-teal-700 border-teal-200",
};

const PRIO = {
  Normal: "bg-slate-100 text-slate-600 border-slate-200",
  Urgent: "bg-red-50 text-red-700 border-red-200",
  "High Priority": "bg-orange-50 text-orange-700 border-orange-200",
};

export function StatusBadge({ status }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${MAP[status] || MAP.Draft}`}>
      {status || "-"}
    </span>
  );
}

export const StageBadge = StatusBadge;

export function PriorityBadge({ priority }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${PRIO[priority] || PRIO.Normal}`}>
      {priority}
    </span>
  );
}
